export default {
  iframe: 'h-full w-full',
  modal: 'h-[90vh] w-[80vw]',
  modalLoading: 'pointer-events-none',
  loader: 'border-[#EC6D25] absolute top-1/2 left-1/2',
};
